/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';

/**
 * 
 * @export
 * @interface EvaluationParameterScopeDto
 */
export interface EvaluationParameterScopeDto {
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationParameterScopeDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof EvaluationParameterScopeDto
     */
    evaluationScopeCategory?: EvaluationScopeCategory;
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    condition?: string | null;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof EvaluationParameterScopeDto
     */
    evaluationParameters?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluationParameterScopeDto
     */
    $type?: EvaluationParameterScopeDtoTypeEnum;
}


/**
 * @export
 */
export const EvaluationParameterScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersEvaluationParameterScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.EvaluationParameterScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EvaluationParameterScopeDtoTypeEnum = typeof EvaluationParameterScopeDtoTypeEnum[keyof typeof EvaluationParameterScopeDtoTypeEnum];



/**
 * Check if a given object implements the EvaluationParameterScopeDto interface.
 */
export function instanceOfEvaluationParameterScopeDto(value?: unknown): value is EvaluationParameterScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EvaluationParameterScopeDtoTypeEnum)[0];
}

export function EvaluationParameterScopeDtoFromJSON(json: any): EvaluationParameterScopeDto {
    return EvaluationParameterScopeDtoFromJSONTyped(json, false);
}

export function EvaluationParameterScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationParameterScopeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'evaluationScopeCategory': json['evaluationScopeCategory'] == null ? undefined : EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        'condition': json['condition'] == null ? undefined : json['condition'],
        'evaluationParameters': json['evaluationParameters'] == null ? undefined : ((json['evaluationParameters'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EvaluationParameterScopeDtoToJSON(value?: EvaluationParameterScopeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'isEnabled': value['isEnabled'],
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value['evaluationScopeCategory']),
        'condition': value['condition'],
        'evaluationParameters': value['evaluationParameters'] == null ? undefined : ((value['evaluationParameters'] as Array<any>).map(EvaluationParameterDtoToJSON)),
        '$type': value['$type'],
    });
}

